import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "constants/UserRoles";

const breadcrumbStatic = [{
	name: 'User Phone Logs',
	url: '/phone_logs/users',
	icon: 'dashboard'
}];

export default class UserPhoneLogs extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.UserPhoneLogs
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							showCSV={this.props.roles.includes(UserRoles.Admin)}
						/>
					</div>
				</div>
			</div>
		)
	}
}